<template>
  <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add_link">
    <v-card-text>
      <v-row>
        <v-container>
          <v-row>
            <v-col>
              <v-form ref="dependantForm" v-model="valid">
                <v-container fluid>
                  <v-row>
                    <v-col xs="12" md="8">
                      <pbas-date-picker
                        :label="
                          $t('components.inmemorydependants.effective_date')
                        "
                        :value="effectiveDate"
                        @update-date="effectiveDate = $event"
                        :rules="[$rules.required, rules.coverageEffectiveDate]"
                        class="required"
                        :allowedDates="coverageAllowedDates"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col cols="12" md="4" v-if="planType === 'Pension'">
                      <trans-select
                        :item="item"
                        propertyName="SourceOfInformation"
                        :items="options.Models.SourceOfInformation"
                        :label="$t('globals.source_of_information')"
                      ></trans-select>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      this.item !== null &&
                        this.item !== undefined &&
                        this.effectiveDate
                    "
                  >
                    <!-- <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                      v-if="planType === 'Pension'"
                    >
                      <no-autocomplete-textfield
                        :disabled="
                          planIdentity.AutogenerateCertificate ||
                            (item.Id !== null &&
                              item.Id !== undefined &&
                              item.Id !==
                                '00000000-0000-0000-0000-000000000000')
                        "
                        :label="
                          $t('headers.in_memory_dependants.pension_spouse_id')
                        "
                        v-model="item.Identity.PensionSpouseId"
                        :rules="[$rules.pensionSpouseId, $rules.required]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col> -->
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <trans-select
                        :item="item"
                        propertyName="Relationship"
                        :items="relationships"
                        :label="
                          $t('components.inmemorydependants.relationship')
                        "
                        :rules="[$rules.required]"
                        class="required"
                      ></trans-select>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.SIN')"
                        v-model="item.SIN"
                        :rules="[$rules.sin]"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <trans-select
                        :clearable="true"
                        :item="item"
                        propertyName="Title"
                        :items="options.Models.Title"
                        :label="$t('headers.members_management.Title')"
                      ></trans-select>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <no-autocomplete-textfield
                        v-model="item.FirstName"
                        :label="$t('globals.firstname')"
                        :rules="[$rules.required, $rules.validName]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <no-autocomplete-textfield
                        v-model="item.MiddleName"
                        :label="$t('globals.middlename')"
                        :rules="[$rules.validMiddleName]"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <no-autocomplete-textfield
                        v-model="item.LastName"
                        :label="$t('globals.lastname')"
                        :rules="[$rules.required, $rules.validLastName]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <trans-select
                        :clearable="true"
                        :item="item"
                        propertyName="Suffix"
                        :items="options.Models.Suffix"
                        :label="$t('headers.members_management.Suffix')"
                      ></trans-select>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <pbas-date-picker
                        :label="$t('globals.dob')"
                        :value="item.DateOfBirth"
                        @update-date="item.DateOfBirth = $event"
                        :rules="[$rules.required, $rules.dateOfBirth]"
                        class="required"
                        :allowedDates="dateOfBirthDates"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <pbas-date-picker
                        clearable
                        :label="$t('components.inmemorydependants.dod')"
                        :value="item.DateOfDeath"
                        @update-date="item.DateOfDeath = $event"
                        :rules="[$rules.dateOfBirth]"
                        :allowedDates="dateOfBirthDates"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="4">
                      <trans-select
                        :item="item"
                        propertyName="Gender"
                        :items="genders"
                        :label="$t('globals.gender')"
                        :rules="[$rules.required]"
                        class="required"
                      ></trans-select>
                    </v-col>
                    <v-col
                      v-if="
                        item &&
                          item.Relationship &&
                          item.Relationship.IsChild &&
                          !item.Relationship.IsSpouse
                      "
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                    >
                      <v-checkbox
                        v-model="item.Disabled"
                        :label="$t('components.inmemorydependants.disabled')"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                      v-if="item && item.Disabled"
                    >
                      <pbas-date-picker
                        clearable
                        :disabled="
                          item.Identity.Qualification.DisabilityApprovalDate !==
                            null &&
                            item.Identity.Qualification
                              .DisabilityApprovalDate !== undefined
                        "
                        :label="
                          $t(
                            'components.inmemorydependants.disability_approval_date'
                          )
                        "
                        :value="itemDisabilityApprovalDate"
                        @update-date="itemDisabilityApprovalDate = $event"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col
                      v-if="
                        item && item.Relationship && item.Relationship.IsChild
                      "
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                    >
                      <v-checkbox
                        v-model="item.Student"
                        :label="$t('components.inmemorydependants.student')"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                      v-if="
                        item &&
                          item.Student &&
                          item.Relationship &&
                          item.Relationship.IsChild
                      "
                    >
                      <pbas-date-picker
                        clearable
                        :label="
                          $t(
                            'components.inmemorydependants.school_completion_date'
                          )
                        "
                        :value="
                          item.Identity.Qualification.SchoolCompletionDate
                        "
                        @update-date="
                          item.Identity.Qualification.SchoolCompletionDate = $event
                        "
                      ></pbas-date-picker>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                      v-if="
                        item && item.Relationship && item.Relationship.IsSpouse
                      "
                    >
                      <pbas-date-picker
                        clearable
                        :disabled="
                          item.Identity.Qualification.DateOfMarriage !== null &&
                            item.Identity.Qualification.DateOfMarriage !==
                              undefined
                        "
                        :label="
                          $t('components.inmemorydependants.date_of_mariage')
                        "
                        :value="itemDateOfMarriage"
                        @update-date="itemDateOfMarriage = $event"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                      v-if="
                        item && item.Relationship && item.Relationship.IsSpouse
                      "
                    >
                      <v-checkbox
                        v-model="item.IsSmoker"
                        :label="$t('components.inmemorydependants.smoker')"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      v-if="
                        useDocumentsManagement &&
                        item && item.Disabled
                      "
                    >
                      <multi-file-upload2
                        id="disabilityId"
                        @emit-upload-end="saving = false"
                        @emit-upload-start="saving = true"
                        :label="
                          $t(
                            'components.inmemorydependants.Proof Of Disability'
                          )
                        "
                        :filesIds="proofOfDisabilityIds"
                        :tags="[planNumber]"
                        :categories="['DependantDisabilityProof']"
                        :currentFolder="planName"
                        :zipDownloadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                        "
                        :fileUploadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                        "
                        @emit-files="
                          bindProofOfDisability($event);
                          saving = false;
                        "
                        @emit-upload-error="
                          error = $event;
                          saving = false;
                        "
                        :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                      />
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      v-if="
                        useDocumentsManagement &&
                        item && item.Student
                      "
                    >
                      <multi-file-upload2
                        id="schoolId"
                        @emit-upload-end="saving = false"
                        @emit-upload-start="saving = true"
                        :label="
                          $t('components.inmemorydependants.Proof Of Schooling')
                        "
                        :tags="[planNumber]"
                        :categories="['DependantSchoolingProof']"
                        :currentFolder="planName"
                        :zipDownloadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                        "
                        :fileUploadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                        "
                        @emit-files="
                          bindProofOfSchooling($event);
                          saving = false;
                        "
                        @emit-upload-error="
                          error = $event;
                          saving = false;
                        "
                        :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                        :filesIds="proofOfSchoolingIds"
                      />
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      v-if="
                        useDocumentsManagement &&
                          item &&
                          item.Relationship &&
                          item.Relationship.IsChild
                      "
                    >
                      <multi-file-upload2
                        id="lifeProofId"
                        @emit-upload-end="saving = false"
                        @emit-upload-start="saving = true"
                        :label="
                          $t(
                            'components.inmemorydependants.Proof Of Life Event'
                          )
                        "
                        :filesIds="proofOfLifeIds"
                        :tags="[planNumber]"
                        :categories="['DependantLifeEventProof']"
                        :currentFolder="planName"
                        :zipDownloadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                        "
                        :fileUploadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                        "
                        @emit-files="
                          bindProofOfLife($event);
                          saving = false;
                        "
                        @emit-upload-error="
                          error = $event;
                          saving = false;
                        "
                        :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                        class="required"
                        :rules="[$rules.atLeastOne]"
                      />
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      v-if="
                        useDocumentsManagement &&
                        item && item.Relationship && item.Relationship.IsSpouse
                      "
                    >
                      <multi-file-upload2
                        id="lawId"
                        @emit-upload-end="saving = false"
                        @emit-upload-start="saving = true"
                        :label="
                          $t(
                            'components.inmemorydependants.Proof Of Common Law Status'
                          )
                        "
                        :tags="[planNumber]"
                        :categories="['DependantCommonLawStatusProof']"
                        :currentFolder="planName"
                        :zipDownloadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                        "
                        :fileUploadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                        "
                        @emit-files="
                          bindProofOfCommonLawStatus($event);
                          saving = false;
                        "
                        @emit-upload-error="
                          error = $event;
                          saving = false;
                        "
                        :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                        :filesIds="proofOfCommonLawStatusIds"
                      />
                    </v-col>
                    <v-col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="4"
                      v-if="
                        planType === 'Pension' &&
                          item &&
                          item.Relationship &&
                          item.Relationship.IsSpouse
                      "
                    >
                      <pbas-date-picker
                        clearable
                        :label="
                          $t(
                            'components.inmemorydependants.spousal_waiver_signal_date'
                          )
                        "
                        :value="item.Identity.Qualification.SpousalWaiverDate"
                        @update-date="updateSpousalWaiverDate($event)"
                        :allowedDates="dateOfBirthDates"
                        :rules="[$rules.dateOfBirth]"
                      ></pbas-date-picker>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      v-if="
                      useDocumentsManagement &&
                        item &&
                          item.Identity &&
                          item.Identity.Qualification.SpousalWaiverDate !==
                            null &&
                          item.Identity.Qualification.SpousalWaiverDate !==
                            undefined
                      "
                    >
                      <multi-file-upload2
                        id="spousalWaiverId"
                        @emit-upload-end="saving = false"
                        :files="files"
                        @emit-upload-start="saving = true"
                        :label="
                          $t('components.inmemorydependants.spousal_waiver')
                        "
                        :tags="[planNumber]"
                        :categories="['DependantSpousalWaiver']"
                        :currentFolder="planName"
                        :zipDownloadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                        "
                        :fileUploadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                        "
                        @emit-files="
                          bindSpousalWaiver($event);
                          saving = false;
                        "
                        @emit-upload-error="
                          error = $event;
                          saving = false;
                        "
                        :filesIds="spousalWaiverIds"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn :disabled="saving" text @click="close(true)">
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn
        :disabled="!valid"
        :loading="saving"
        color="primary"
        @click="trySave"
      >
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <!-- <v-dialog
      scrollable
      v-model="spouseAsBeneficiaryWarningDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.dependant_form.add_spouse_as_beneficiary_warning')
        "
        color="#007cb5"
        icon="done"
      >
        <v-card-actions>
          <v-btn color text @click="spouseAsBeneficiaryWarningDialog=false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              save
            "
          >
            {{ $t("components.dependant_form.add_spouse_as_beneficiary") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog> -->
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import TransSelect from "@/components/TransSelect";
import { locker } from "@/mixins/locker";
import { translate } from "@/trans";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { createMemberFile } from "@/makeMemberFile";
import MultiFileUpload2 from "@/components/MultiFileUpload2.vue";
import SettingsService from "@/services/settings.service.js";

export default {
  name: "dependant-form",
  components: {
    ErrorHandler,
    TransSelect,
    NoAutocompleteTextfield,
    MultiFileUpload2,
  },
  props: [
    "memberId",
    "editedIndex",
    "memberName",
    "identityId",
    "coverageEffectiveDate",
    "policyIdentities",
    "beneficiaryStatements",
    "files",
    "planId",
    "planType",
    "planName",
    "planNumber",
  ],
  mixins: [locker],
  data() {
    return {
      proofOfSchoolingIds: null,
      proofOfDisabilityIds: null,
      proofOfCommonLawStatusIds: null,
      proofOfLifeIds: null,
      spousalWaiverIds: null,
      selectedRelationship: null,
      isSpouse: false,
      spouseExists: false,
      itemDisabilityApprovalDate: null,
      itemDateOfMarriage: null,
      relationships: [],
      maritalStatus: null,
      deleteValid: true,
      effectiveDate: undefined,
      error: null,
      valid: false,
      items: [],
      saving: false,
      genders: [],
      snackbar: false,
      color: "",
      mode: "",
      item: null,
      timeout: 2500,
      message: "",
      defaultItem: {
        Identity: {
          Qualification: {},
        },
      },
      // spouseAsBeneficiaryWarningDialog: false
      rules:{
        coverageEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (this.coverageEffectiveDate === null || this.coverageEffectiveDate === undefined) {
            return true;
          }
          console.log(v, this.coverageEffectiveDate);
          return (
            this.coverageAllowedDates(v) ||
            this.$t("validation.date_{0}", [this.formatDate(new Date(this.coverageEffectiveDate))])
          );
        },
      }
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options", "planIdentity"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
    title() {
      return this.editedIndex === -1
        ? this.$t("components.memberview.add_dependant_{0}", [this.memberName])
        : this.$t("components.memberview.edit_dependant_{0}", [this.memberName]);
    },
  },
  watch: {
    effectiveDate: {
      async handler(v) {
        if (v) {
          try {
            let item = this.defaultItem;
            // console.log(this.editedIndex);
            if (this.editedIndex > -1) {
              if (this.lockId) {
                item = (await this.getByEffectiveDate({
                  entity: "dependants",
                  plan: this.planId,
                  id: this.identityId,
                  date: v,
                  expand:
                    "$expand=Identity($expand=Qualification($expand=ProofOfSchooling($expand=FileSegments($select=PhysicalFileId)),ProofOfDisability($expand=FileSegments($select=PhysicalFileId)),ProofOfCommonLawStatus($expand=FileSegments($select=PhysicalFileId)))),Suffix($expand=Translations($select=LanguageCode,DisplayValue)),Title($expand=Translations($select=LanguageCode,DisplayValue)),Relationship($expand=Translations($select=LanguageCode,DisplayValue)),Gender($select=Name,Id;$expand=Translations($select=LanguageCode,DisplayValue))",
                })).data;
              } else {
                item = await this.lock(
                  this.getByEffectiveDate,
                  {
                    entity: "dependants",
                    plan: this.planId,
                    id: this.identityId,
                    date: v,
                    expand:
                      "$expand=SourceOfInformation($expand=Translations),Identity($expand=Qualification($expand=ProofOfSchooling($expand=FileSegments($select=PhysicalFileId)),ProofOfDisability($expand=FileSegments($select=PhysicalFileId)),ProofOfCommonLawStatus($expand=FileSegments($select=PhysicalFileId)))),Suffix($expand=Translations($select=LanguageCode,DisplayValue)),Title($expand=Translations($select=LanguageCode,DisplayValue)),Relationship($expand=Translations($select=LanguageCode,DisplayValue)),Gender($select=Name,Id;$expand=Translations($select=LanguageCode,DisplayValue))",
                    dialogs: this.dialogs,
                    dialog: "edit",
                  },
                  () => {
                    this.dialogs.edit = false;
                  }
                );
              }
              if (item.Identity && item.Identity.Qualification) {
                this.itemDisabilityApprovalDate =
                  item.Identity.Qualification.DisabilityApprovalDate;
                this.itemDateOfMarriage =
                  item.Identity.Qualification.DateOfMarriage;
                if (item.Identity.Qualification.ProofOfCommonLawStatus) {
                  const files =
                    item.Identity.Qualification.ProofOfCommonLawStatus
                      .FileSegments;
                  this.proofOfCommonLawStatusIds = files.map(
                    (x) => x.PhysicalFileId
                  );
                }
                if (item.Identity.Qualification.ProofOfDisability) {
                  const files =
                    item.Identity.Qualification.ProofOfDisability.FileSegments;
                  this.proofOfDisabilityIds = files.map(
                    (x) => x.PhysicalFileId
                  );
                }
                if (item.Identity.Qualification.ProofOfSchooling) {
                  const files =
                    item.Identity.Qualification.ProofOfSchooling.FileSegments;
                  this.proofOfSchoolingIds = files.map((x) => x.PhysicalFileId);
                }
                if (item.Identity.Qualification.ProofOfLifeEvent) {
                  const files =
                    item.Identity.Qualification.ProofOfLifeEvent.FileSegments;
                  this.proofOfLifeIds = files.map((x) => x.PhysicalFileId);
                }
                if (item.Identity.Qualification.SpousalWaiver) {
                  const files =
                    item.Identity.Qualification.SpousalWaiver.FileSegments;
                  this.spousalWaiverIds = files.map((x) => x.PhysicalFileId);
                }
              } else {
                item.Identity = {
                  Qualification: {},
                };
              }

              if (this.planType === "Pension") {
                this.relationships = this.options.Models.Relationship.filter(
                  (o) => o.IsSpouse
                );
              } else {
                if (item.Relationship.IsSpouse === true) {
                  this.relationships = this.options.Models.Relationship.filter(
                    (o) => o.IsSpouse
                  );
                } else if (item.Relationship.IsChild === true) {
                  this.relationships = this.options.Models.Relationship.filter(
                    (o) => o.IsChild
                  );
                } else {
                  this.relationships = this.options.Models.Relationship;
                }
              }

              this.spouseExists = (await this.memberHasSpouse({
                planIdentityId: this.planId,
                memberIdentityId: this.memberId,
              })).data;
              this.isSpouse = item.Relationship.IsSpouse;
            } else {
              if (!this.lockId) {
                await this.lock(
                  this.lockWizard,
                  {
                    plan: this.memberId,
                    dialogs: this.dialogs,
                    dialog: "edit",
                  },
                  () => {
                    this.dialogs.edit = false;
                  }
                );
              }

              item = JSON.parse(JSON.stringify(this.defaultItem));
              // if (this.planIdentity.AutogenerateCertificate) {
              //   if (this.planType === "Pension") {
              //     item.Identity.PensionSpouseId = (await this.getNewCertificate(
              //       {
              //         planIdentityId: this.planIdentityId,
              //         entity: "Spouse",
              //       }
              //     )).data.value;
              //   }
              // }
              this.maritalStatus = (await this.getMemberFamilyStatusByEffectiveDate(
                {
                  planIdentityId: this.planId,
                  memberIdentityId: this.memberId,
                  effectiveDate: v,
                }
              )).data.CurrentMember.MaritalStatus;
              // console.log(this.maritalStatus, item);
              if (this.planType === "Pension") {
                this.relationships = this.options.Models.Relationship.filter(
                  (o) => o.IsSpouse
                );
              } else {
                if (
                  this.maritalStatus === null ||
                  this.maritalStatus === undefined
                ) {
                  this.relationships = this.options.Models.Relationship;
                } else if (this.maritalStatus.AllowSpouse === false) {
                  this.relationships = this.options.Models.Relationship.filter(
                    (o) => !o.IsSpouse
                  );
                } else {
                  this.relationships = this.options.Models.Relationship;
                }
              }
              this.spouseExists = (await this.memberHasSpouse({
                planIdentityId: this.planId,
                memberIdentityId: this.memberId,
              })).data;
            }
            this.item = item;
          } catch (error) {
            this.error = error;
          }
        }
      },
    },
    "item.Relationship": {
      handler(v) {
        // console.log("relationship: ", v);
        if (v !== null && v !== undefined) {
          if (!v.IsChild) {
            this.item.Student = false;
          }
          if (!v.IsChild || v.IsSpouse) {
            this.item.Disabled = false;
          }
          if (!v.IsSpouse) {
            this.itemDateOfMarriage = null;
            this.item.IsSmoker = false;
          }
          // console.log(this.item);
          if (this.selectedRelationship !== this.item.Relationship) {
            this.selectedRelationship = this.item.Relationship;
            // if (this.planIdentity.UseDocumentManagement) {
            this.resetBinds();
            // }
            // console.log(this.item);
          }
        }
      },
      immediate: true,
    },
    "item.Student": {
      handler(v) {
        if (!v && this.item !== null && this.item !== undefined) {
          delete this.item.Identity.Qualification.SchoolCompletionDate;
        }
      },
      immediate: true,
    },
    "item.Disabled": {
      handler(v) {
        if (!v && this.item !== null && this.item !== undefined) {
          this.itemDisabilityApprovalDate = null;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    ...mapActions("plansMembers", [
      "getByEffectiveDate",
      "updateDependant",
      "newDependant",
      "lockWizard",
      "getMemberFamilyStatusByEffectiveDate",
      "getSpouseCount",
      "newDependantAndBeneficiary",
      "getNewCertificate",
      "releaseCertificate",
      "memberHasSpouse",
    ]),
    formatDate(d) {
      console.log(d);
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    bindProofOfSchooling(memberFile) {
      this.item.Identity.Qualification.ProofOfSchooling = createMemberFile(
        memberFile,
        "DependantSchoolingProof",
        this.memberId
      );
    },
    bindProofOfDisability(memberFile) {
      this.item.Identity.Qualification.ProofOfDisability = createMemberFile(
        memberFile,
        "DependantDisabilityProof",
        this.memberId
      );
    },
    bindProofOfCommonLawStatus(memberFile) {
      this.item.Identity.Qualification.ProofOfCommonLawStatus = createMemberFile(
        memberFile,
        "DependantCommonLawStatusProof",
        this.memberId
      );
    },
    bindSpousalWaiver(memberFile) {
      this.item.Identity.Qualification.SpousalWaiver = createMemberFile(
        memberFile,
        "DependantSpousalWaiver",
        this.memberId
      );
    },
    bindProofOfLife(memberFile) {
      this.item.Identity.Qualification.ProofOfLifeEvent = createMemberFile(
        memberFile,
        "DependantLifeEventProof",
        this.memberId
      );
    },
    resetBinds() {
      if (this.item.Identity.Qualification.ProofOfSchooling) {
        delete this.item.Identity.Qualification.ProofOfSchooling;
      }
      if (this.item.Identity.Qualification.ProofOfDisability) {
        delete this.item.Identity.Qualification.ProofOfDisability;
      }
      if (this.item.Identity.Qualification.ProofOfCommonLawStatus) {
        delete this.item.Identity.Qualification.ProofOfCommonLawStatus;
      }
      if (this.item.Identity.Qualification.SpousalWaiver) {
        delete this.item.Identity.Qualification.SpousalWaiver;
      }
    },
    trans(item) {
      return translate(item, this.language.language);
    },
    coverageAllowedDates(val) {
      // console.log(this.coverageEffectiveDate);
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.coverageEffectiveDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    dateOfBirthDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const d2 = new Date();
      return d <= d2;
    },
    async loadPlanData() {
      try {
        this.genders = this.options.Models.Gender;
        // console.log(t)
      } catch (error) {
        this.error = error;
      }
    },
    close(cancel) {
      if (this.planType === "Pension" && cancel) {
        this.releaseCertificate({
          planIdentityId: this.planId,
          payload: {
            Certificates: [this.item.Identity.PensionSpouseId],
          },
        });
      }
      if (this.$refs.dependantForm) this.$refs.dependantForm.resetValidation();
      this.item = null;
      this.effectiveDate = null;
      this.itemDisabilityApprovalDate = null;
      this.itemDateOfMarriage = null;
      this.unlock();
      this.$emit("close");
    },
    trySave() {
      // if (
      //   this.item.Identity.Qualification.SpousalWaiverDate === null ||
      //   this.item.Identity.Qualification.SpousalWaiverDate === undefined
      // ) {
      //   this.spouseAsBeneficiaryWarningDialog = true;
      // } else {
      this.save();
      // }
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      if (this.spouseExists && item.Relationship.IsSpouse) {
        // if (this.spouseExists) {
        let error = new Error();
        error.customMessage = this.$t(
          "components.inmemorydependants.spouse_exists"
        );
        this.error = error;
        return;
        // }
      }
      if (!item.Relationship.IsChild) {
        item.Student = false;
      }
      if (item.Relationship.IsSpouse) {
        item.Identity.Qualification.DateOfMarriage = this.itemDateOfMarriage;
        if (!item.IsSmoker) {
          item.IsSmoker = false;
        }
      } else {
        item.Identity.Qualification.DateOfMarriage = null;
        item.IsSmoker = false;
      }
      if (item.Disabled) {
        item.Identity.Qualification.DisabilityApprovalDate = this.itemDisabilityApprovalDate;
      } else {
        item.Identity.Qualification.DisabilityApprovalDate = null;
      }

      item.EffectiveDate = this.effectiveDate;
      if (item.Relationship) {
        item.RelationshipId = item.Relationship.Id;
        delete item.Relationship;
      }
      if (Object.keys(item.Identity.Qualification) === 0) {
        delete item.Identity;
      }
      // if (Object.keys(item.BeneficiaryStatement) === 0) {
      //   delete item.BeneficiaryStatement;
      // }
      if (item.Gender) {
        item.GenderId = item.Gender.Id;
        delete item.Gender;
      }
      if (item.Title) {
        item.TitleId = item.Title.Id;
        delete item.Title;
      }
      if (item.Suffix) {
        item.SuffixId = item.Suffix.Id;
        delete item.Suffix;
      }
      if (item.SourceOfInformation) {
        item.SourceOfInformationId = item.SourceOfInformation.Id;
        delete item.SourceOfInformation;
      }
      delete item["@odata.context"];
      if (this.editedIndex > -1) {
        this.update(item);
      } else {
        this.add(item);
      }
    },
    async update(item) {
      try {
        await this.updateDependant({
          plan: this.planId,
          member: this.memberId,
          payload: item,
          id: this.item.IdentityId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close(false);
        this.$emit("save");
      } catch (error) {
        this.error = error;
      }
    },
    async add(item) {
      // console.log(this.beneficiaryStatements);
      if (
        this.planType === "Pension" &&
        (this.beneficiaryStatements === null ||
          this.beneficiaryStatements === undefined ||
          this.beneficiaryStatements.length === 0)
      ) {
        const beneficiaryStatement = await this.createSpouseBeneficiaryStatement(
          item
        );
        // console.log(beneficiaryStatement);
        try {
          await this.newDependantAndBeneficiary({
            plan: this.planId,
            member: this.memberId,
            payload: {
              Spouse: item,
              BeneficiaryStatement: beneficiaryStatement,
            },
          });
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.close(false);
          this.$emit("save");
        } catch (error) {
          this.error = error;
        }
      } else {
        try {
          await this.newDependant({
            plan: this.planId,
            member: this.memberId,
            payload: item,
          });
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.close(false);
          this.$emit("save");
        } catch (error) {
          this.error = error;
        }
      }
    },
    async createSpouseBeneficiaryStatement(spouse) {
      const cert = (await this.getNewCertificate({
        planIdentityId: this.planId,
        entity: "PrimaryBeneficiary",
      })).data.value;
      const beneficiaryStatement = {
        DeclarationDate: spouse.EffectiveDate,
        PolicyIdentities: this.policyIdentities,
        Beneficiaries: [
          {
            PensionBeneficiaryId: cert,
            BeneficiaryTypeId: this.options.Models.BeneficiaryType.filter(
              (o) => o.Name === "Person"
            )[0].Id,
            BeneficiaryRelationshipId: this.options.Models.BeneficiaryRelationship.filter(
              (o) => o.IsSpouse
            )[0].Id,
            DependantIdentity: spouse,
            IsPrimary: true,
            IsRevocable: true,
            Percentage: 1.0,
          },
        ],
      };
      // console.log(JSON.stringify(beneficiaryStatement));
      return beneficiaryStatement;
    },
    async tryDelete() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.EffectiveDate = this.effectiveDate;
      item.IsRemoved = true;
      if (item.Relationship) {
        item.RelationshipId = item.Relationship.Id;
        delete item.Relationship;
      }
      if (item.Gender) {
        item.GenderId = item.Gender.Id;
        delete item.Gender;
      }
      delete item["@odata.context"];
      try {
        await this.updateDependant({
          plan: this.planId,
          member: this.memberId,
          payload: item,
          id: this.item.IdentityId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.delete = false;
        this.effectiveDate = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    updateSpousalWaiverDate(date) {
      this.item.Identity.Qualification.SpousalWaiverDate = date;
      this.$forceUpdate();
    },
  },
};
</script>
